// Generated from shared/retryRead.mjs by sync-assets.mjs.
// Only use for idempotent reads, including the history query POST. Never retry
// rejected credentials, plan limits, malformed responses or user cancellation.
const cancelled = signal => Object.assign(new Error('Request cancelled.'), { code: 'request_cancelled',
  termination_reason: ['account_changed','replaced','navigation','view_closed'].includes(signal?.reason) ? signal.reason : 'cancelled' });

export function retryAfterMilliseconds(headers, now = Date.now()) {
  const value = headers?.get?.('Retry-After');
  if (!value) return 0;
  const seconds = Number(value);
  const delay = Number.isFinite(seconds) ? seconds * 1000 : Date.parse(value) - now;
  return Number.isFinite(delay) ? Math.max(0, delay) : 0;
}

export function waitForReadRetry(milliseconds, signal) {
  return new Promise((resolve, reject) => {
    const abort = () => { clearTimeout(timer); signal?.removeEventListener('abort', abort); reject(cancelled(signal)); };
    const timer = setTimeout(() => { signal?.removeEventListener('abort', abort); resolve(); }, milliseconds);
    signal?.addEventListener('abort', abort, { once: true });
    if (signal?.aborted) abort();
  });
}

export async function retryRead(request, { signal, maxElapsedMs = 20000, wait = waitForReadRetry,
  onRecovered = () => {}, clock = Date.now } = {}) {
  const started = clock();
  let retries = 0, lastCode;
  for (;;) {
    if (signal?.aborted) throw cancelled(signal);
    try {
      const value = await request(Math.max(1, maxElapsedMs - (clock() - started)));
      if (signal?.aborted) throw cancelled(signal);
      if (retries) {
        try { onRecovered({ retry_count: retries, error_code: lastCode, elapsed_ms: Math.max(0, clock() - started) }); } catch {}
      }
      return value;
    } catch (error) {
      const status = Number(error?.status);
      const stopped = ['request_cancelled','malformed_response','guest_session_expired','guest_session_ended',
        'guest_daily_limit','daily_limit_reached'].includes(error?.code) || error?.name === 'AbortError';
      const temporary = !stopped && ((error?.code === 'auth_verification_unavailable' && (!status || status === 503))
        || [502, 503, 504].includes(status)
        || (!status && ['network_failed','request_network_error','request_timeout'].includes(error?.code)));
      const pause = Math.max(1000 * 2 ** retries, Number(error?.retryAfterMs) || 0);
      if (signal?.aborted) throw cancelled(signal);
      if (!temporary || retries >= 2 || clock() - started + pause >= maxElapsedMs) throw error;
      lastCode = error?.code || `http_${status}`;
      retries++;
      await wait(pause, signal);
    }
  }
}
